var map = {
	"./Kế Toán/Hệ thống thông tin kế toán 1.json": 50398,
	"./Kế Toán/Hệ thống thông tin kế toán 2.json": 23973,
	"./Kế Toán/Hệ thống thông tin kế toán.json": 70014,
	"./Kế Toán/Kinh tế lượng 1.json": 91451,
	"./Kế Toán/Kiểm soát nội bộ.json": 9529,
	"./Kế Toán/Kiểm toán căn bản.json": 19734,
	"./Kế Toán/Kiểm toán tài chính 1.json": 2500,
	"./Kế Toán/Kế toán chi phí.json": 62644,
	"./Kế Toán/Kế toán công 1.json": 31345,
	"./Kế Toán/Kế toán công ty.json": 18358,
	"./Kế Toán/Kế toán dự án đầu tư.json": 8865,
	"./Kế Toán/Kế toán quản trị 1.json": 84184,
	"./Kế Toán/Kế toán quản trị 2.json": 61235,
	"./Kế Toán/Kế toán quốc tế.json": 71908,
	"./Kế Toán/Kế toán tài chính 1.json": 70493,
	"./Kế Toán/Kế toán tài chính 2.json": 29910,
	"./Kế Toán/Kế toán tài chính 3.json": 21613,
	"./Kế Toán/Lập và Quản lý dự án đầu tư.json": 37827,
	"./Kế Toán/Lịch sử kinh tế.json": 55558,
	"./Kế Toán/Ngân hàng thương mại.json": 64804,
	"./Kế Toán/Phân tích báo cáo tài chính.json": 24230,
	"./Kế Toán/Phân tích kinh doanh.json": 53704,
	"./Kế Toán/Quản lý công nghệ.json": 58782,
	"./Kế Toán/Thuế.json": 5875,
	"./Kế Toán/Thẩm định dự án đầu tư.json": 47033,
	"./Kế Toán/Đề án môn học - Kế toán.json": 15835,
	"./Luật Kinh Tế/Chuyên đề Pháp luật chứng khoán.json": 70733,
	"./Luật Kinh Tế/Công pháp quốc tế.json": 24511,
	"./Luật Kinh Tế/Dân số và phát triển.json": 65153,
	"./Luật Kinh Tế/Kinh tế công cộng 1.json": 70839,
	"./Luật Kinh Tế/Kỹ năng tư vấn pháp luật cộng đồng.json": 87200,
	"./Luật Kinh Tế/Kỹ năng tư vấn pháp luật.json": 14803,
	"./Luật Kinh Tế/Kỹ năng xác lập và thực hiện hợp đồng thương mại.json": 18325,
	"./Luật Kinh Tế/Luật WTO.json": 17653,
	"./Luật Kinh Tế/Luật dân sự 1.json": 13743,
	"./Luật Kinh Tế/Luật dân sự 2.json": 96409,
	"./Luật Kinh Tế/Luật hiến pháp.json": 82869,
	"./Luật Kinh Tế/Luật hành chính.json": 35423,
	"./Luật Kinh Tế/Luật hình sự 1.json": 53773,
	"./Luật Kinh Tế/Luật hình sự 2.json": 99648,
	"./Luật Kinh Tế/Luật lao động.json": 10811,
	"./Luật Kinh Tế/Luật sở hữu trí tuệ.json": 119,
	"./Luật Kinh Tế/Luật thương mại 1.json": 51281,
	"./Luật Kinh Tế/Luật thương mại 2.json": 47447,
	"./Luật Kinh Tế/Luật thương mại quốc tế.json": 88877,
	"./Luật Kinh Tế/Luật tố tụng dân sự.json": 70351,
	"./Luật Kinh Tế/Luật tố tụng hành chính.json": 24632,
	"./Luật Kinh Tế/Luật tố tụng hình sự.json": 14136,
	"./Luật Kinh Tế/Lý luận nhà nước và pháp luật 1.json": 41939,
	"./Luật Kinh Tế/Lý luận nhà nước và pháp luật 2.json": 82475,
	"./Luật Kinh Tế/Pháp luật an sinh xã hội.json": 49335,
	"./Luật Kinh Tế/Pháp luật chứng khoán.json": 13527,
	"./Luật Kinh Tế/Pháp luật cạnh tranh.json": 32140,
	"./Luật Kinh Tế/Pháp luật giao dịch điện tử.json": 32509,
	"./Luật Kinh Tế/Pháp luật hôn nhân và gia đình.json": 71102,
	"./Luật Kinh Tế/Pháp luật môi trường.json": 63655,
	"./Luật Kinh Tế/Pháp luật ngân hàng.json": 68047,
	"./Luật Kinh Tế/Pháp luật tài chính.json": 64647,
	"./Luật Kinh Tế/Pháp luật về đầu tư.json": 93402,
	"./Luật Kinh Tế/Pháp luật đất đai.json": 4579,
	"./Luật Kinh Tế/Pháp luật đấu thầu.json": 33105,
	"./Luật Kinh Tế/Pháp luật đầu tư.json": 56274,
	"./Luật Kinh Tế/Tư pháp quốc tế.json": 3085,
	"./Luật Kinh Tế/Xây dựng văn bản pháp luật.json": 45811,
	"./Luật Kinh Tế/Đề án môn học Luật Thương mại.json": 18066,
	"./Môn Đại Cương/Chủ nghĩa Mác - Lênin 1.json": 97598,
	"./Môn Đại Cương/Chủ nghĩa Mác - Lênin 2.json": 78898,
	"./Môn Đại Cương/Chủ nghĩa xã hội khoa học.json": 74710,
	"./Môn Đại Cương/Kinh tế chính trị Mác - Lênin.json": 3296,
	"./Môn Đại Cương/Kinh tế quốc tế.json": 57109,
	"./Môn Đại Cương/Kinh tế vi mô 1.json": 42740,
	"./Môn Đại Cương/Kinh tế vi mô 2.json": 12957,
	"./Môn Đại Cương/Kinh tế vĩ mô 1.json": 44023,
	"./Môn Đại Cương/Kế toán tài chính (Bản mới).json": 21905,
	"./Môn Đại Cương/Kỹ năng quản trị.json": 48537,
	"./Môn Đại Cương/Lý thuyết tài chính tiền tệ 1.json": 65031,
	"./Môn Đại Cương/Lý thuyết tài chính tiền tệ 2.json": 51918,
	"./Môn Đại Cương/Lập kế hoạch và khởi nghiếp.json": 13713,
	"./Môn Đại Cương/Lịch sử Đảng Cộng sản Việt Nam.json": 80167,
	"./Môn Đại Cương/Marketing căn bản.json": 84570,
	"./Môn Đại Cương/Nghiên cứu kinh doanh.json": 83200,
	"./Môn Đại Cương/Nguyên lý kế toán.json": 70260,
	"./Môn Đại Cương/Nguyên lý thống kê.json": 65767,
	"./Môn Đại Cương/Nhập môn Internet (ICT).json": 56924,
	"./Môn Đại Cương/Pháp luật kinh doanh.json": 41558,
	"./Môn Đại Cương/Pháp luật đại cương.json": 564,
	"./Môn Đại Cương/Phát triển ký năng cá nhân (PSD).json": 49068,
	"./Môn Đại Cương/Phương pháp tối ưu trong kinh doanh.json": 95747,
	"./Môn Đại Cương/Quản lý học 1.json": 4174,
	"./Môn Đại Cương/Quản trị chất lượng dịch vụ.json": 21533,
	"./Môn Đại Cương/Quản trị kinh doanh 1.json": 11783,
	"./Môn Đại Cương/Quản trị tài chính.json": 99160,
	"./Môn Đại Cương/Quản trị văn phòng.json": 43008,
	"./Môn Đại Cương/Thống kê chất lượng.json": 33848,
	"./Môn Đại Cương/Thống kê kinh doanh.json": 14994,
	"./Môn Đại Cương/Thống kê trong kinh tế và kinh doanh.json": 8184,
	"./Môn Đại Cương/Toán cho các nhà kinh tế.json": 52443,
	"./Môn Đại Cương/Triết học Mác - Lênin.json": 10045,
	"./Môn Đại Cương/Tài chính công 2.json": 28353,
	"./Môn Đại Cương/Tài chính công.json": 72131,
	"./Môn Đại Cương/Tư tưởng Hồ Chí Minh.json": 70061,
	"./Môn Đại Cương/Đường lối cách mạng của Đảng Cộng sản Việt Nam.json": 28160,
	"./Môn Đại Cương/Đổi mới sáng tạo.json": 55508,
	"./Quản Trị Kinh Doanh/Giao tiếp kinh doanh và thuyết trình.json": 16785,
	"./Quản Trị Kinh Doanh/Khởi sự kinh doanh.json": 59577,
	"./Quản Trị Kinh Doanh/Kinh doanh quốc tế 1.json": 60331,
	"./Quản Trị Kinh Doanh/Kinh doanh quốc tế.json": 33801,
	"./Quản Trị Kinh Doanh/Kiểm soát.json": 41509,
	"./Quản Trị Kinh Doanh/Quản trị Marketing.json": 20375,
	"./Quản Trị Kinh Doanh/Quản trị chi phí kinh doanh.json": 52088,
	"./Quản Trị Kinh Doanh/Quản trị chiến lược 1.json": 38446,
	"./Quản Trị Kinh Doanh/Quản trị chiến lược 2.json": 90803,
	"./Quản Trị Kinh Doanh/Quản trị chất lượng.json": 9219,
	"./Quản Trị Kinh Doanh/Quản trị doanh nghiệp.json": 764,
	"./Quản Trị Kinh Doanh/Quản trị giám sát.json": 31683,
	"./Quản Trị Kinh Doanh/Quản trị hậu cần.json": 17647,
	"./Quản Trị Kinh Doanh/Quản trị kinh doanh 2.json": 80400,
	"./Quản Trị Kinh Doanh/Quản trị kinh doanh bảo hiểm.json": 70726,
	"./Quản Trị Kinh Doanh/Quản trị kinh doanh thương mại.json": 43652,
	"./Quản Trị Kinh Doanh/Quản trị nhân lực.json": 69274,
	"./Quản Trị Kinh Doanh/Quản trị quá trình kinh doanh.json": 9367,
	"./Quản Trị Kinh Doanh/Quản trị tác nghiệp 1.json": 65957,
	"./Quản Trị Kinh Doanh/Quản trị tác nghiệp 2.json": 44624,
	"./Quản Trị Kinh Doanh/Quản trị vận hành 2.json": 98492,
	"./Quản Trị Kinh Doanh/Quản trị vận hành.json": 16416,
	"./Quản Trị Kinh Doanh/Quản trị đa văn hóa.json": 20692,
	"./Quản Trị Kinh Doanh/Quản trị điều hành dự án.json": 29788,
	"./Quản Trị Kinh Doanh/Tiêu chuẩn hóa.json": 62435,
	"./Quản Trị Kinh Doanh/Tái lập doanh nghiệp.json": 93661,
	"./Quản Trị Kinh Doanh/Văn hóa doanh nghiệp.json": 65790,
	"./Quản Trị Kinh Doanh/Văn hóa và đạo đức kinh doanh.json": 6844,
	"./Quản Trị Kinh Doanh/Đạo đức kinh doanh.json": 23389,
	"./Tài Chính Ngân hàng/Bảo hiểm thương mại 1.json": 92493,
	"./Tài Chính Ngân hàng/Chuyên đề Marketing Ngân hàng.json": 15104,
	"./Tài Chính Ngân hàng/Kinh tế thương mại.json": 28698,
	"./Tài Chính Ngân hàng/Kế toán ngân hàng.json": 70045,
	"./Tài Chính Ngân hàng/Lý thuyết xác suất và thống kê toán.json": 21850,
	"./Tài Chính Ngân hàng/Nguyên lý bảo hiểm.json": 67533,
	"./Tài Chính Ngân hàng/Ngân hàng phát triển.json": 74938,
	"./Tài Chính Ngân hàng/Ngân hàng thương mại 1.json": 50474,
	"./Tài Chính Ngân hàng/Ngân hàng thương mại 2.json": 11630,
	"./Tài Chính Ngân hàng/Ngân hàng trung ương.json": 34097,
	"./Tài Chính Ngân hàng/Phân tích tài chính.json": 68645,
	"./Tài Chính Ngân hàng/Phân tích và đầu tư chứng khoán.json": 46124,
	"./Tài Chính Ngân hàng/Quản lý thuế.json": 47073,
	"./Tài Chính Ngân hàng/Quản trị rủi ro.json": 74460,
	"./Tài Chính Ngân hàng/Thanh toán quốc tế.json": 9143,
	"./Tài Chính Ngân hàng/Thuế quốc tế.json": 89741,
	"./Tài Chính Ngân hàng/Thị trường chứng khoán 1.json": 39142,
	"./Tài Chính Ngân hàng/Thị trường chứng khoán 2.json": 36164,
	"./Tài Chính Ngân hàng/Thị trường chứng khoán nợ.json": 47204,
	"./Tài Chính Ngân hàng/Toán tài chính.json": 35625,
	"./Tài Chính Ngân hàng/Tài chính doanh nghiệp 1.json": 64619,
	"./Tài Chính Ngân hàng/Tài chính doanh nghiệp 2.json": 99876,
	"./Tài Chính Ngân hàng/Tài chính quốc tế 1.json": 87402,
	"./Tài Chính Ngân hàng/Đại số.json": 82624,
	"./Tài Chính Ngân hàng/Đề án Lý thuyết tài chính tiền tệ.json": 43535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7403;